import MenuHeader from "./components/MenuHeader";
import BasicModal from "../../components/BasicModal";
import useMainFrame from "./useMainFrame";
import MainBox from "./components/MainBox";
import MainStructure from "../MainStructure/MainStructure";
import DocumentModal from "../../components/DocumentModal/DocumentModal";
import { MainContext } from "../../context/MainContext";
import { versionsAccess } from "../../data/main";
import StationeryModal from "../../components/StationeryModal/StationeryModal";
import { stdObject } from "../../data/types/stdObject";
import MainFooter from "./components/MainFooter";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import CalendarModal from "../../components/CalendarModal/CalendarModal";
import { sectionsList } from "../../data/sectionsList";

export default function MainFrame({
  logoutAction,
}: {
  logoutAction: () => void;
}) {
  const {
    cVersion,
    userAccess,
    mainMenuheader,
    setMainMenuHeader,
    openServiceModal,
    updateListCodeRef,
    customUpdate,
    msg,
    msg2,
    msg3,
    docModal,
    stationeryModal,
    calendarModal,
    msgData,
    setMsg,
    openMsg,
    closeMsg,
    closeCalendar,
    setModalData,
    askLogout,
    openWindow,
    windowValues,
    closeMsgDoc,
    selectMode,
    setSelectMode,
    returnToDoc,
    updateDocData,
    desactivateScrollDown,
    activeDoc,
    alarms,
    statusDict,
    openItemOptions,
    insertNewItem,
    openActiveDocList,
    updateDocFilesList,
    askDeleteMainInfo,
    addUpdateImage,
    openUserInfo,
    openHeaderInfo,
    openRecordInfo,
    openMainInfo,
    handleMainData,
    selectStep,
    currentDate,
    calDocsList,
    setCalDocsList,
    openWebInfo,
    setDocValues,
    setStationeryModal,
    setWindowValues,
    setMsg2,
    docValues,
    setMsg3,
    setModalData2,
    setModalData3,
    documentAction,
    windowValues2,
    setWindowValues2,
    changeBranch,
    createUserToken,
    openNotifications,
    openCalendar,
    checkIfAllMsgClean,
    createNewCalendar,
    openBatchRecords,
  } = useMainFrame({
    logoutAction,
  });

  const user: any = useSelector((state: RootState) => state.data.user);

  return (
    <MainContext.Provider
      value={{
        updateListCodeRef,
        openServiceModal,
        customUpdate,
        mainMenuheader,
        setMainMenuHeader,
        selectMode,
        setSelectMode,
        returnToDoc,
        updateDocData,
        desactivateScrollDown,
        statusDict,
        openItemOptions,
        insertNewItem,
        setMsg,
        openMsg,
        closeMsg,
        closeCalendar,
        setModalData,
        openWindow,
        windowValues,
        openActiveDocList,
        updateDocFilesList,
        logoutAction,
        askDeleteMainInfo,
        addUpdateImage,
        openUserInfo,
        openHeaderInfo,
        openRecordInfo,
        openMainInfo,
        handleMainData,
        selectStep,
        currentDate,
        calDocsList,
        setCalDocsList,
        openWebInfo,
        setDocValues,
        setStationeryModal,
        setWindowValues,
        setMsg2,
        docValues,
        setMsg3,
        setModalData2,
        setModalData3,
        documentAction,
        windowValues2,
        setWindowValues2,
        changeBranch,
        createUserToken,
        openNotifications,
        openCalendar,
        checkIfAllMsgClean,
        createNewCalendar,
        openBatchRecords,
      }}
    >
      <div className="columnBox">
        {!selectMode.active && (
          <MenuHeader
            askLogout={askLogout}
            changeBranch={changeBranch}
            activeDoc={activeDoc}
            alarms={alarms}
          />
        )}
        <div style={{ flex: 1, position: "relative" }}>
          {sectionsList
            .filter(
              (e: stdObject) =>
                (["B", "C"].includes(e.id) && user.VENTAS) ||
                !["B", "C"].includes(e.id),
            )
            .filter((e: stdObject) => versionsAccess[cVersion].includes(e.id))
            .map((e, index) => (
              <MainStructure
                key={index}
                type={typeof e.type === "string" ? e.type : ""}
                subSections={userAccess[e.id]}
                height={mainMenuheader.type === e.type ? "100%" : "0%"}
                peopleId={e.peopleId}
              />
            ))}
          <MainBox
            height={!mainMenuheader.type ? "100%" : "0%"}
            cVersion={cVersion}
          />
        </div>
        <MainFooter />

        {calendarModal.open && (
          <CalendarModal open={calendarModal.open} close={closeCalendar} />
        )}
        {stationeryModal !== "" && (
          <StationeryModal
            open={stationeryModal !== ""}
            info={
              stationeryModal in msgData
                ? msgData[stationeryModal as keyof typeof msgData]
                : {}
            }
          />
        )}
        <DocumentModal
          open={docModal !== ""}
          close={closeMsgDoc}
          info={
            docModal in msgData ? msgData[docModal as keyof typeof msgData] : {}
          }
        />
        <BasicModal
          open={msg !== ""}
          close={closeMsg}
          data={msg in msgData ? msgData[msg as keyof typeof msgData] : {}}
        />
        <BasicModal
          open={msg2 !== ""}
          close={() => closeMsg(2)}
          data={msg2 in msgData ? msgData[msg2 as keyof typeof msgData] : {}}
          zIndexs={{ z1: 52, z2: 53 }}
        />
        <BasicModal
          open={msg3 !== ""}
          close={() => closeMsg(3)}
          data={msg3 in msgData ? msgData[msg3 as keyof typeof msgData] : {}}
          zIndexs={{ z1: 54, z2: 55 }}
        />
      </div>
    </MainContext.Provider>
  );
}
